<template>
    <div v-loading.fullscreen="loading">
        <div v-if="!loading">
            <el-breadcrumb
                v-if="hasRoleToReadLogs"
                style="float: right"
                separator-class="el-icon-arrow-right"
            >
                <el-breadcrumb-item :to="{ path: '/' }">{{$t('route.home')}}</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ name: 'teamList' }">{$t('entities.team.plural')}}</el-breadcrumb-item>
                <el-breadcrumb-item>{{ model.name }}</el-breadcrumb-item>
            </el-breadcrumb>

            <h2 class="page-title">{{$t('entities.team.singular')}}</h2>

            <el-row :gutter="20">
                <!-- Left -->
                <el-col :span="8">
                    <el-form
                        :label-position="labelPosition"
                        :label-width="labelWidth"
                        :class="{ show: true, 'show-mobile': isMobile }"
                        v-on:submit.native.prevent
                    >
                        <el-form-item v-if="hasRoleToReadLogs" label="Id">{{ model.id }}</el-form-item>

                        <el-form-item :label="$t('entities.team.prop.name')">{{ model.name }}</el-form-item>

                        <el-form-item :label="$t('entities.team.prop.category')">
                            <app-entity-link entityName="category" :property="model.category"></app-entity-link>
                        </el-form-item>

                        <el-form-item :label="$t('entities.club.singular')">{{ model.club.name }}</el-form-item>

                        <el-form-item
                            v-if="hasRoleToReadLogs"
                            :label="$t('entities.team.prop.locality')"
                        >{{ model.locality }}</el-form-item>

                        <el-form-item
                            v-if="hasRoleToReadLogs"
                            :label="$t('entities.team.prop.country')"
                        >{{ model.country }}</el-form-item>

                        <el-form-item
                            v-if="hasRoleToReadLogs"
                            :label="$t('entities.team.prop.web')"
                        >{{ model.web }}</el-form-item>

                        <el-form-item
                            v-if="hasRoleToReadLogs"
                            :label="$t('status.created')"
                        >{{ model.created | formatDatetime }}</el-form-item>

                        <el-form-item
                            v-if="hasRoleToReadLogs"
                            :label="$t('status.modifiedAt')"
                        >{{ model.modified | formatDatetime }}</el-form-item>

                        <div class="button-group mt-3">
                            <el-button
                                v-if="hasRoleToUpdate"
                                icon="el-icon-fa-pencil-square-o"
                                @click="edit()"
                                type="primary"
                            >{{$t('table.edit')}}</el-button>
                            <el-button
                                v-if="hasRoleToReadLogs"
                                icon="el-icon-fa-history"
                                @click="history()"
                                type="infor"
                            >{{$t('table.history')}}</el-button>
                            <el-button
                                v-if="hasRoleToDelete"
                                icon="el-icon-fa-trash"
                                @click="destroy()"
                                type="danger"
                            >{{$t('table.delete')}}</el-button>
                        </div>
                    </el-form>
                </el-col>
                <!-- Rigth -->
                <el-col :span="8">
                    <coach-list :teamId="model.id"></coach-list>
                </el-col>
                <el-col :span="8">
                    <team-manager-list :teamId="model.id"></team-manager-list>
                </el-col>
            </el-row>

            <!-- * ******************** -->
            <!-- *      Player List     * -->
            <!-- ********************** -->
            <player-list :teamId="model.id"></player-list>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import PlayerList from "@/entities/player/player-list";
import CoachList from "@/entities/coach/coach-list";
import TeamManagerList from "@/entities/team-manager/team-manager-list";

export default {
    name: "app-team-show",

    components: {
        playerList: PlayerList,
        coachList: CoachList,
        teamManagerList: TeamManagerList
    },

    props: {
        id: String
    },

    created() {
        this.$store
            .dispatch("entities/team/detail", this.id)
            .catch(() => this.$router.push({ name: "teamList" }));
    },

    beforeRouteLeave(to, from, next) {
        /**
         * Si no estamos en detalles de equipo y no creamos un equipo, reseteamos el estado del equipo
         */
        if (from.name === "teamShow" 
            && ( to.name === "playerNew"
            || to.name === "coachNew"
            || to.name === "teamManagerNew"
            )
            ) {
                // En otras palabras, si vamos a crear un jugador, coach o delegado desde el detalle de un equipo, entonces no borramos el estado del equipo (ya que lo necesitaremos)
            next();
        } else {
            this.$store.dispatch("entities/team/clear");
            next();
        }
    },

    computed: {
        ...mapGetters({
            model: "entities/team/model",
            loading: "entities/team/loading",
            hasRoleToDelete: "entities/team/hasRoleToDelete",
            hasRoleToUpdate: "entities/team/hasRoleToUpdate",
            hasRoleToRead: "entities/team/hasRoleToRead",
            hasRoleToReadLogs: "entities/team/hasRoleToReadLogs",
            hasRoleToCreate: "entities/team/hasRoleToCreate",
            isMobile: "shared/isMobile",
            labelPosition: "shared/labelPosition",
            labelWidth: "shared/labelWidth"
        })
    },

    methods: {
        edit() {
            this.$router.push({
                name: "teamEdit",
                params: { id: this.id, previous: "show" }
            });
        },

        destroy() {
            this.$confirm("Are you sure?", "Confirm", {
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                type: "warning"
            })
                .then(() =>
                    this.$store.dispatch("entities/team/destroy", this.model)
                )
                .then(() => this.$router.go(-1))
                .catch(() => {});
        },

        history() {
            this.$router.push({
                name: "teamHistorySingle",
                params: { id: this.id }
            });
        }
    }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/entities/team/team-show.vue?036a3854